import axios from 'axios';

export default () => {
  return {
    namespaced: true,
    state: {
      settings: {},
    },
    mutations: {
      SET_SETTINGS(state, { data, locale }) {
        state.settings = data;
      },
    },
    actions: {
      FETCH_SETTINGS({ state, commit }, { locale }) {
        const params = {
          lang: null,
        };
        return axios(`/api/accessibility/${locale}/accessibility.json`, { params })
        // return axios(`http://localhost:8080/static/accessibility/${locale}.accessibility.json`, { params })
          .then((result) => {
            const data = result.data;
            commit('SET_SETTINGS', { data, locale });
          })
          .catch((err) => {
            throw err;
          });
      },
    },
    getters: {
      getSettings(state) {
        return state.settings;
      },
    },
  };
};
